import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconAdd = ({ t, fill = '#000', height = 30, width = 30, className }) => (
  <svg width={height} height={width} className={className} viewBox='0 0 29 29'>
    <title>{t('Plus')}</title>
    <g transform='translate(-5 -5)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <g stroke={fill} strokeLinecap='round' strokeWidth={4}>
        <path d='M7 19.5h25M19.5 7v25' />
      </g>
    </g>
  </svg>
)

export default Icon(IconAdd)
